import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,findArrayObject } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import AddEditFrieghtAmount from '../../../components/Trip/AddEditFrieghtAmount';
import AddEditTruckHireCost from '../../../components/Trip/AddEditTruckHireCost';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    justifyContent:'space-between',
    boxShadow:'none',
    paddingTop:16,
    borderTop:'1px dotted #6b778c'
  },
  icon:{
    fontSize:16,
    color:'#03c',
    cursor:'pointer'
  },
  listLabel:{
    fontSize:16,
    fontWeight:600,
    color:'#0b1323'
  },
  amount:{
    color:'#03c',
    fontWeight:600,
    fontSize:16,
    marginRight:24
  }
}));
const JourneyTripTruckHireCostCard = (props) => {
  const {trip,journey,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let transactions = journey && journey.vendorTransactions ? journey.vendorTransactions:[];
  let charges = transactions && transactions.charges?transactions.charges:[]
  let transData = findArrayObject("transactionType", 'Vehicle_Hire_Cost', charges && charges.list?charges.list:null); 
  const [addEditHireCostOpen,setAddEditHireCostOpen] = useState(false)
  const handleAddEditHireCostClose = () => {
    setAddEditHireCostOpen(false);
  }
  const handleAddEditHireCostSave = () => {
    setAddEditHireCostOpen(false);
  }
  return (
    <>
      <Box width={'100%'} padding={'0 24px'} marginTop={'8px'}>
        <Paper component='div' className={classes.card} >
            <Typography className={classes.listLabel}>Truck Hire Cost</Typography>
            <Box display="flex" alignItems="center">
              <Typography className={classes.amount}>{numberFormat(transData && transData.amount?transData.amount:0)}</Typography>
              <EditIcon onClick={()=>{setAddEditHireCostOpen(true)}} className={classes.icon}/>
            </Box>
        </Paper>
      </Box>
      {addEditHireCostOpen && <AddEditTruckHireCost editData={transData} selectedTrip={trip} updateJourney={updateJourney} open={addEditHireCostOpen} onClose={handleAddEditHireCostClose} onSave={handleAddEditHireCostSave} />}
    </>
  );
}
export default JourneyTripTruckHireCostCard;